<template>
  <div>
    <v-progress-linear
      v-if="isSplitConfigurationLoading"
      class="mt-5 mb-7"
      indeterminate
      rounded
    />
    <div v-else>
      <h6 class="text-uppercase grey--text">
        {{ $t('split.label.vendor') }}
      </h6>
      <p class="body-2">
        {{
          splitConfiguration && splitConfiguration.vendor
            ? splitConfiguration.vendor.name
            : '---'
        }}
      </p>

      <h6 class="text-uppercase grey--text">
        {{ $t('split.label.description') }}
      </h6>
      <p class="body-2">
        {{
          splitConfiguration && splitConfiguration.description
            ? splitConfiguration.description
            : '---'
        }}
      </p>

      <v-row>
        <v-col cols="12" sm="6">
          <v-card class="pa-3" outlined>
            <h4 class="grey--text mt-2">
              {{ $t('split.label.hostTakeRate') }}
            </h4>
            <v-row no-gutter>
              <v-col>
                <h6 class="text-uppercase grey--text">
                  {{ $t('split.label.mode') }}
                </h6>
                <p class="body-2 mb-0 text-capitalize">
                  {{
                    splitConfiguration &&
                    activeMode(splitConfiguration.host_take_rate_mode)
                  }}
                </p>
              </v-col>
              <v-col>
                <h6 class="text-uppercase grey--text">
                  {{ $t('split.label.tax') }}
                </h6>
                <p class="body-2 mb-0 text-capitalize">
                  {{
                    splitConfiguration &&
                    splitMode(
                      splitConfiguration.host_take_rate,
                      splitConfiguration.host_take_rate_mode
                    )
                  }}
                </p>
              </v-col>
            </v-row>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6">
          <v-card class="pa-3" outlined>
            <h4 class="grey--text mt-2">
              {{ $t('split.label.customerTakeRate') }}
            </h4>
            <v-row no-gutter>
              <v-col>
                <h6 class="text-uppercase grey--text">
                  {{ $t('split.label.mode') }}
                </h6>
                <p class="body-2 mb-0 text-capitalize">
                  {{
                    splitConfiguration &&
                    activeMode(splitConfiguration.customer_take_rate_mode)
                  }}
                </p>
              </v-col>
              <v-col>
                <h6 class="text-uppercase grey--text">
                  {{ $t('split.label.tax') }}
                </h6>
                <p class="body-2 mb-0 text-capitalize">
                  {{
                    splitConfiguration &&
                    splitMode(
                      splitConfiguration.customer_take_rate,
                      splitConfiguration.customer_take_rate_mode
                    )
                  }}
                </p>
              </v-col>
            </v-row>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6">
          <v-card class="pa-3" outlined>
            <h4 class="grey--text mt-2">
              {{ $t('split.label.hausefulTakeRate') }}
            </h4>
            <v-row no-gutter>
              <v-col>
                <h6 class="text-uppercase grey--text">
                  {{ $t('split.label.mode') }}
                </h6>
                <p class="body-2 mb-0 text-capitalize">
                  {{
                    splitConfiguration &&
                    activeMode(splitConfiguration.hauseful_take_rate_mode)
                  }}
                </p>
              </v-col>
              <v-col>
                <h6 class="text-uppercase grey--text">
                  {{ $t('split.label.tax') }}
                </h6>
                <p class="body-2 mb-0 text-capitalize">
                  {{
                    splitConfiguration &&
                    splitMode(
                      splitConfiguration.hauseful_take_rate,
                      splitConfiguration.hauseful_take_rate_mode
                    )
                  }}
                </p>
              </v-col>
            </v-row>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6">
          <v-card v-if="hasPartner" class="pa-3" outlined>
            <h4 class="grey--text mt-2">
              {{ $t('split.label.partnerTakeRate') }}
            </h4>
            <v-row no-gutter>
              <v-col>
                <h6 class="text-uppercase grey--text">
                  {{ $t('split.label.mode') }}
                </h6>
                <p class="body-2 mb-0 text-capitalize">
                  {{
                    splitConfiguration &&
                    activeMode(splitConfiguration.partner_take_rate_mode)
                  }}
                </p>
              </v-col>
              <v-col>
                <h6 class="text-uppercase grey--text">
                  {{ $t('split.label.tax') }}
                </h6>
                <p class="body-2 mb-0 text-capitalize">
                  {{
                    splitConfiguration &&
                    splitMode(
                      splitConfiguration.partner_take_rate,
                      splitConfiguration.partner_take_rate_mode
                    )
                  }}
                </p>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { splitMode } from '../utils'

export default {
  name: 'SplitConfigurationDetails',

  data() {
    return {
      splitMode,
    }
  },

  computed: {
    ...mapGetters(['splitConfiguration', 'isSplitConfigurationLoading']),

    hasPartner() {
      return (
        this.splitConfiguration &&
        this.splitConfiguration.partner_take_rate_mode &&
        this.splitConfiguration.partner_take_rate
      )
    },
  },

  methods: {
    activeMode(status) {
      return status
        ? this.$t('split.label.percentage')
        : this.$t('split.label.fixAmount')
    },
  },
}
</script>
